export enum DocType {
  Paystub = "paystub",
  W2 = "w2",
  BankStatement = "bank_statement"
}

export enum ReverifyFlows {
  SelectOption,
  ReVerifyWithDocuments,
  SendRequest
}

export enum VerificationType {
  Bank = "bank",
  Payroll = "payroll",
  Documents = "documents"
}
